module.exports = [{type: 0,name: 'span',ref: 'null',attributes:{"class":"demo-chip",},props:{},eventHandlers:{},children: [function(){return this.label},],},]